export const NATIONALITIES = [
    {
        label: "Egyptian",
        value: "egyptian",
    },
    {
        label: "Syrian",
        value: "syrian",
    },
    {
        label: "Sudanian",
        value: "sudanian",
    },
];

export const SUPPLIER_TYPES = [
    { value: "supplier_agent", label: "Supplier Agent" },
    { value: "contractor", label: "Contractor" },
    { value: "broker", label: "Broker" },
];

export const PAYMENT_METHODS = [
    { value: "bank_account", label: "Bank Account" },
    { value: "mezza_card", label: "Mezza Card" },
    { value: "e_wallet", label: "E Wallet" },
];

export const QA_STATUS = [
    { value: "pending_verification", label: "Pending verification" },
    { value: "verified", label: "Verified" },
    { value: "unverified", label: "Unverified" },
];
